import { gettext } from '@eventbrite/i18n';
import React, { useRef } from 'react';
import { useScrollOnCommand } from '../../../contexts/ScrollContext';
import {
    EventDetailsMainInner,
    EventDetailsSection,
    EventDetailsSectionTitle,
} from '../EventDetails';

export type RefundPolicyProps = {
    isEnableRetainFeeActive: boolean;
    isPaidEvent: boolean;
    isRefundRequestAllowed: boolean;
    refundPolicyDescription: string;
    refundPolicyIsNoRefunds: boolean;
};

export const RefundPolicy = ({
    isEnableRetainFeeActive,
    isPaidEvent,
    isRefundRequestAllowed,
    refundPolicyDescription,
    refundPolicyIsNoRefunds,
}: RefundPolicyProps) => {
    const ref = useRef<HTMLDivElement>(null);
    useScrollOnCommand(ref, 'refundPolicy');
    if (!isPaidEvent) {
        return null;
    }
    const isNonFeeRefundable =
        isEnableRetainFeeActive && !refundPolicyIsNoRefunds;
    const isRequiredContactOrganizer =
        !refundPolicyDescription && isRefundRequestAllowed;
    const isNonRefunds =
        isEnableRetainFeeActive &&
        !refundPolicyDescription &&
        !isRefundRequestAllowed;
    const LABEL_ID = 'refund-policy-heading';

    if (
        !refundPolicyDescription &&
        !isRequiredContactOrganizer &&
        !isNonFeeRefundable &&
        !isNonRefunds
    ) {
        return null;
    }

    return (
        <EventDetailsMainInner>
            <EventDetailsSection ariaLabelledBy={LABEL_ID}>
                <span ref={ref} />
                <EventDetailsSectionTitle>
                    <h2>{gettext('Refund Policy')}</h2>
                </EventDetailsSectionTitle>

                {refundPolicyDescription && (
                    <div
                        // eslint-disable-next-line react/no-danger
                        dangerouslySetInnerHTML={{
                            __html: refundPolicyDescription.toString(),
                        }}
                    />
                )}
                {isRequiredContactOrganizer && (
                    <div>
                        {gettext('Contact the organizer to request a refund.')}
                    </div>
                )}
                {isNonFeeRefundable && !isNonRefunds && (
                    <div>{gettext("Eventbrite's fee is nonrefundable.")}</div>
                )}
                {isNonRefunds && <div>{gettext('No Refunds')}</div>}
            </EventDetailsSection>
        </EventDetailsMainInner>
    );
};
